export default {
  landing: {
    hero: {
      tag: "Candidatures ouvertes",
      title: "Trouvez votre formation en alternance",
    },
    error: "Impossible de charger la page. Vérifiez le lien reçu ou réessayez plus tard.",
    retry: "Réessayer",
    sections: {
      contact: {
        title: "Vos coordonnées",
        first_name: "Prénom",
        last_name: "Nom",
        email: "Adresse email",
        phone: "Téléphone",
        last_degree: "Dernier diplôme obtenu",
        last_school: "Dernier établissement",
        optional: "(facultatif)",
        required_indicator: "champ obligatoire",
        required_error: "Ce champ est obligatoire.",
        email_error: "L'adresse email n'est pas valide. Format attendu : nom@exemple.fr",
      },
      training: {
        title: "Nos formations",
        more_info: "Plus d'informations",
        modal: {
          close: "Fermer",
          brochure: "Télécharger la brochure",
          select: "Choisir cette formation",
          selected: "Formation sélectionnée",
        },
      },
      project: {
        preselected_note:
          "Vous arrivez pour « {name} », déjà sélectionnée ci-dessous. D'autres formations proches pourraient aussi vous intéresser.",
      },
      origin: {
        title: "Comment nous avez-vous connus ?",
      },
      consent: {
        aria_label: "Consentement",
        text: "J'accepte les conditions générales et la politique de confidentialité. Désinscription possible à tout moment.",
        privacy_policy_link: "politique de confidentialité",
        required_error: "Merci d'accepter les conditions pour continuer.",
        captcha_label: "Vérification anti-robot",
      },
    },
    final: {
      info_button: "Recevoir des informations",
      apply_button: "Candidater",
      rgpd_note: "Vos données sont traitées conformément au RGPD.",
      privacy_policy_link: "Politique de confidentialité",
      privacy_policy_title: "Politique de confidentialité",
      info_success: "Merci ! Nous vous enverrons des informations très prochainement.",
      info_sent_title: "Merci pour votre intérêt !",
      info_sent_text:
        "Votre demande a bien été transmise. L'équipe du CFA va vous envoyer des informations sur la formation qui vous intéresse.",
      info_sent_resume_title: "Et si vous souhaitez candidater ?",
      info_sent_resume_text:
        "Nous venons de vous envoyer un e-mail à l'adresse {email}. Il contient un lien pour reprendre votre candidature quand vous le souhaitez, sans avoir à ressaisir vos informations.",
      info_sent_spam_note: "Vous ne trouvez pas l'e-mail ? Pensez à regarder dans vos courriers indésirables.",
      already_registered: "Votre dossier existe déjà, nous reviendrons vers vous si nécessaire.",
    },
  },
  // TA-4768/4769 : clé top-level (pas sous "landing") - tous les appels $t("candidacyGroups...")
  // du code (CandidacyGroupsView/CandidacyFormationGroupsComponent/LandingGroupRankBadgeComponent)
  // utilisent ce chemin sans préfixe "landing.".
  candidacyGroups: {
    hero: {
      tag: "Votre candidature",
      title: "Choisir un groupe",
      title_success: "Merci !",
    },
    intro:
      "Vous avez manifesté un intérêt pour la ou les formations ci-dessous. Pour chacune, sélectionnez le ou les groupes auxquels vous souhaitez candidater et classez-les par ordre de préférence.",
    loading: "Chargement de vos formations…",
    error: "Impossible de charger vos formations. Vérifiez le lien reçu ou réessayez plus tard.",
    empty: "Aucune formation à afficher.",
    no_groups_title: "Aucune candidature ouverte pour le moment",
    no_groups_sub: "Le CFA vous informera dès l'ouverture des candidatures pour cette formation.",
    entry_year: "{year}ᵉ année",
    start_date: "Début : {date}",
    rank: {
      selected: "Choix n°{rank}",
      locked: "Groupe non sélectionnable",
    },
    move_up: "Monter {name} dans le classement",
    move_down: "Descendre {name} dans le classement",
    max_choices_reached: "Vous pouvez sélectionner {max} groupes au maximum.",
    validate_button: "Valider ma candidature",
    confirm_title: "Valider votre candidature ?",
    confirm_text:
      "Vos choix seront transmis au CFA et un email vous invitera à activer votre compte. Vous pourrez encore modifier votre classement ensuite.",
    confirm_button: "Valider",
    success: "Candidature transmise ! Vous allez recevoir un email pour activer votre compte.",
    success_title: "Votre dossier de candidature est créé",
    success_text:
      "Encore une étape : <strong>confirmez votre adresse e-mail</strong>. Cette vérification nous assure que c'est bien vous et que vous recevrez toutes les informations sur votre candidature.",
    success_box_title: "Consultez vos e-mails maintenant",
    success_step1: "Ouvrez l'email que nous venons de vous envoyer.",
    success_step2: "Cliquez sur le lien de vérification : votre espace candidat s'ouvre.",
    success_step3: "Complétez votre dossier et déposez vos documents.",
    success_note:
      "Vous ne trouvez pas l'e-mail ? Regardez dans vos courriers indésirables (spam). Votre candidature ne sera étudiée qu'une fois votre dossier complété.",
  },
  secureData: {
    hero: {
      tag: "Vos données sont en sécurité",
      title: "Reprendre ou recommencer",
    },
    intro:
      "Nous avons bien conservé votre demande. Choisissez comment continuer : reprenez là où vous en étiez, ou saisissez à nouveau vos coordonnées.",
    resume_title: "Reprendre là où j'en étais",
    resume_sub: "Recevez un lien unique par email pour retrouver votre formulaire pré-rempli.",
    restart_title: "Saisir à nouveau",
    loading: "Vérification de votre lien…",
    error: "Impossible d'ouvrir cette page. Vérifiez le lien reçu ou réessayez plus tard.",
    mail_sent: "Email envoyé ! Vérifiez votre boîte de réception pour continuer.",
    resume_ok: "Bonjour {name}, votre demande est prête à être reprise.",
    resume_continue: "Continuer vers ma candidature",
    prefill_choice: "Choisissez comment continuer :",
    resume_expired: "Ce lien a expiré ou a déjà été utilisé. Demandez-en un nouveau ci-dessous.",
    resend_link: "Recevoir un nouveau lien",
    restart_intro: "Vos nouvelles coordonnées remplaceront celles de votre dossier existant.",
    restart_submit: "Valider mes coordonnées",
    restart_error: "Vérifiez vos coordonnées : l'email doit être celui de votre demande initiale.",
    restart_ok: "Coordonnées mises à jour !",
  },
  unsubscribe: {
    hero: {
      tag: "Ne plus recevoir nos messages",
      title: "Se désabonner",
    },
    intro:
      "Vous pouvez vous désabonner en un clic. Si vous le souhaitez, indiquez-nous votre motif ci-dessous — il nous aide à améliorer nos communications.",
    reasons_label: "Motif de désabonnement",
    error: "Impossible d'ouvrir cette page. Vérifiez le lien reçu ou réessayez plus tard.",
    submit: "Confirmer ma désinscription",
    submit_error: "Impossible d'enregistrer votre désinscription. Réessayez plus tard.",
    optional_note: "La validation reste possible sans sélectionner de motif.",
    done: "C'est noté, vous ne recevrez plus nos communications.",
    reasons: {
      admitted_elsewhere: {
        title: "Admis ailleurs",
        sub: "Vous avez trouvé une formation dans un autre établissement.",
      },
      not_interested: { title: "Plus intéressé(e)", sub: "Ce projet ne correspond plus à votre orientation." },
      not_the_requester: {
        title: "Pas à l'origine de la demande",
        sub: "Vous n'êtes pas à l'origine de cette demande d'informations.",
      },
      other: { title: "Autre", sub: "Un autre motif que ceux proposés ci-dessus." },
    },
  },
};
